import React from "react";
import { useState } from "react";
import useUnsettledClaim from "../../../hooks/UseUnsettledClaim";
import "./UnsettledClaims.scss";
import _ from "lodash";
import { Link } from "react-router-dom";
import { useEffect } from "react";

const pageSize = 20;

const UnsettledClaims = () => {
  // actual unsettle claim data
  const [unsettledClaimData, setUnsettledClaim, loading] = useUnsettledClaim();
  // console.log(unsettledClaimData);
  // !actual unsettle claim data

  // for serach data state
  const [searchUnsetClaim, setSearchUnsetClaim] = useState("");
  // !for serach data state

  // paginated data
  const [paginatedData, setPaginatedData] = useState("");
  // !paginated data

  //   currentPage pagination page state
  const [currentPage, setCurrentPage] = useState(1);
  //   !currentPage pagination page state

  useEffect(() => {
    setPaginatedData(_(unsettledClaimData).slice(0).take(pageSize).value());
  }, [unsettledClaimData]);

  // console.log("setPaginatedData", paginatedData);

  // for search function
  const handleSearchUnsetClaim = (e) => {
    setSearchUnsetClaim(e.target.value);
    console.log(searchUnsetClaim);
  };
  // !for search function

  const pageCount = unsettledClaimData
    ? Math.ceil(unsettledClaimData.length) / pageSize
    : 0;
  if (pageCount === 1) return null;

  const pages = _.range(1, pageCount + 1);

  //   pagination on click
  const handlePagination = (pageNo) => {
    setCurrentPage(pageNo);
    const startIndex = (pageNo - 1) * pageSize;
    const paginatedItems = _(unsettledClaimData)
      .slice(startIndex)
      .take(pageSize)
      .value();
    setPaginatedData(paginatedItems);
  };
  //   !pagination on click

  return (
    <>
      <div className="unsettled_claims">
        {}
        <div className="container">
          <div className="heading_box">Unsettled Claim</div>
          <input
            type="text"
            placeholder="Search here by Policy/Certificate Number"
            className="form-control my-5"
            onChange={handleSearchUnsetClaim}
          />

          {paginatedData && loading ? (
            <div className="table-responsive">
              <table className="table border text-center unset_claim_table">
                <thead>
                  <tr>
                    <th scope="col">SL No.</th>
                    <th scope="col">Policy/Certificate Number</th>
                    <th scope="col">Policy/Certificate Issuing Date.</th>
                    <th scope="col">Date of Information</th>
                    <th scope="col">Estimate Amount of Loss</th>
                    <th scope="col">Number of Day's the claim was Unsettled</th>
                    <th scope="col">Reason For Non Settlement</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData
                    .filter((val) => {
                      if (unsettledClaimData === "") {
                        return val;
                      } else if (
                        val.PolicyCertificateNumber.toLowerCase().includes(
                          searchUnsetClaim.toLowerCase().replace(/\s+/g, "")
                        )
                        // ||
                        // val.PolicyCertificateIssuingDate.toLowerCase().includes(
                        //   searchUnsetClaim.toLowerCase().replace(/\s+/g, "")
                        // )
                      )
                        return val;
                    })
                    .map((unClaim, index) => (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        {/* <th scope="row">{unClaim.id}</th> */}
                        <td>{unClaim.PolicyCertificateNumber}</td>
                        <td>{unClaim.PolicyCertificateIssuingDate}</td>
                        <td>{unClaim.DateOfIntimation}</td>
                        <td>{unClaim.AmountOfLoss}</td>
                        <td>{unClaim.NumberOfDaysPending}</td>
                        <td>{unClaim.Reason}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center my-5">
              <button className="btn btn-danger w-50" type="button">
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            </div>
          )}

          <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-center my-5">
              {pages.map((page, index) => (
                <li
                  className={
                    page === currentPage ? "page-item active" : "page-item"
                  }
                  key={index}
                >
                  <p
                    className="page-link"
                    onClick={() => handlePagination(page)}
                  >
                    {page}
                  </p>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export default UnsettledClaims;
